<sc-flex [formGroup]="formGroup">

  <sc-checkbox-field formControlName="checked"
  [label]="supplementaryEquipment.name"></sc-checkbox-field>

  <sc-content-spacer></sc-content-spacer>

  @if (supplementaryEquipment.identifier != null) {
    <sc-read-only-field labelDictionaryKey="tmc-common.equipment.entity.equipment.identifier"
    [value]="supplementaryEquipment.identifier" style="width: 180px;"></sc-read-only-field>
  }

</sc-flex>
